import { render, staticRenderFns } from "./RLabel.vue?vue&type=template&id=2cb76322&"
import script from "./RLabel.vue?vue&type=script&lang=js&"
export * from "./RLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports